//#region imports

import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { InstanceProxy } from '../../models/proxys/instance.proxy';
import { HttpAsyncService } from '../../modules/http-async/services/http-async.service';

//#endregion

@Injectable({
  providedIn: 'root',
})
export class InstanceService {

  //#region constructor

  constructor(
    protected readonly router: Router,
    protected readonly http: HttpAsyncService,
    protected readonly title: Title,
  ) { }

  //#endregion

  //#region Public Properties

  public currentInstance?: InstanceProxy;

  //#endregion

  //#region Public Methods

  public async initializeInstance(): Promise<void> {
    const subdomain = this.getCurrentSubdomain();

    await this.loadInstanceBySubdomain(subdomain);

    (window as any).afiliatedGetInstance = () => this.currentInstance;

    (window as any).afiliatedSetCurrentInstanceBySubdomain = (domain: any) => this.loadInstanceBySubdomain(domain);

    (window as any).afiliatedClearForcedSubdomain = () => localStorage.removeItem(environment.keys.forceSubdomain);

    (window as any).afiliatedForceSubdomain = (domain: any) => {
      localStorage.setItem(environment.keys.forceSubdomain, domain);

      this.loadInstanceBySubdomain(domain);
    };
  }

  public getCurrentSubdomain(): string {
    const overrideSubdomain = localStorage.getItem(environment.keys.forceSubdomain);

    if (overrideSubdomain)
      return overrideSubdomain;

    const url = location.hostname;

    if (!environment.production && !environment.hmr && !environment.qa)
      return 'facens';

    if (environment.qa) {
      const domain = url.split('.')[0];
      return domain;
    }

    return url.split('.')[1] || 'localhost';
  }

  //#endregion

  //#region Private Methods

  private async loadInstanceBySubdomain(subdomain: string): Promise<void> {
    const { error, success } = await this.http.get<number>(`/companies/domain/${subdomain}`);

    if (!success || error)
      return void await this.router.navigateByUrl('/instance-not-found');

    this.setupInstance(success);
  }

  private setupInstance(instance: number): void {
    environment.COMPANY_ID = instance;
  }

  //#endregion

}
